<template>
    <div class="page-container">
        <tabs :active-tab="activeTab"
              @changed="onTabChange">
            <tab title="Schedule">
                <camp-list :school-id="schoolId"></camp-list>
            </tab>
            <tab title="Calendar">
                <base-calendar>
                    <camp-calendar :school-id="schoolId">
                    </camp-calendar>
                </base-calendar>
            </tab>
        </tabs>
    </div>
</template>

<script>
    import { mapActions, mapGetters, mapMutations } from 'vuex';
    import * as Mutations from '@/store/modules/page/mutations';
    import * as Routes from '@/router/routes';
    import store from '@/store/store';
    import { TabRouteChangeMixin } from '@/mixins/TabRouteChangeMixin';
    import { headerToolsMixin } from '@/mixins/headerToolsMixin';
    import BaseCalendar from '../base/BaseCalendar';

    export default {
        name: 'ClassPage',
        components: {
            BaseCalendar,
            CampCalendar: () => import(/* webpackChunkName: "camps"*/ './CampCalendar'),
            CampList: () => import(/* webpackChunkName: "camps"*/ './CampList'),
            Stats: () => import(/* webpackChunkName: "camps"*/ '../../Stats'),
            Tabs: () => import('../../../controls/Tabs'),
            Tab: () => import('../../../controls/Tab')
        },
        props: {
            tab: String,
            default: Routes.CAMP_PAGE
        },
        mixins: [TabRouteChangeMixin, headerToolsMixin({
            name: 'IconBtnTool',
            propsData: {
                icon: 'grey-config',
                callback: () => store.dispatch('openModal', { modalName: 'CampSettingsModal' })
            },
            permission: {
                name: 'camps.camps',
                rules: 'settings'
            }
        })],
        computed: {
            ...mapGetters(['schoolId'])
        },
        methods: {
            ...mapActions([
                'removeStats',
                'changeActivityCalendarDate',
                'changeActivityCalendarMode'
            ]),
            ...mapMutations({
                removeAllFilters: Mutations.REMOVE_ALL_FILTERS
            }),
            onTabChange(tab) {
                switch (tab) {
                    case 'Schedule':
                        this.$router.push({ name: Routes.CAMP_PAGE });
                        break;
                    case 'Calendar':
                        this.$router.push({ name: Routes.CAMP_CALENDAR });
                        break;
                }
            }
        },
        beforeDestroy() {
            this.removeStats();
        },
        beforeRouteLeave(to, from, next) {
            !to.path.includes('camps') && this.removeAllFilters();
            next()
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/main/pages/camps/CampPage.vue